var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M238.335,415.571c7.454-5.568,13.931-7.388,23.954-9.209c10.025-1.82,20.614-4.926,26.167-6.426 c5.601-1.552-18.816,7.388-25.036,9.157C257.304,410.965,238.335,415.571,238.335,415.571L238.335,415.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M278.689,399.892c-2.006-12.594,2.979-25.857,14.392-31.152 C295.755,377.891,287.58,393.414,278.689,399.892L278.689,399.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M298.171,393.364c-6.117-10.539,4.164-24.059,11.823-30.639 C313.542,369.047,307.32,387.914,298.171,393.364L298.171,393.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.111,385.242c-6.477-8.996,1.234-24.728,9.459-30.947 C328.757,363.188,325.57,379.123,316.111,385.242L316.111,385.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M334.103,373.932c-5.961-8.483-1.798-21.643,6.785-30.229 C347.008,350.8,341.762,366.118,334.103,373.932L334.103,373.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M348.55,362.623c-4.988-8.02,1.129-27.194,9.149-32.49 C361.144,337.226,358.573,357.277,348.55,362.623L348.55,362.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M360.013,359.59c-1.44-11.465,18.608-24.162,26.783-23.801 C385.922,345.143,377.337,355.424,360.013,359.59L360.013,359.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M348.806,372.543c9.459-9.662,27.71-9.662,34.185-7.659 C381.295,370.54,359.705,382.826,348.806,372.543L348.806,372.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M335.851,382.26c13.263-3.548,21.848-6.427,29.765,1.798 C360.013,391.154,338.525,389.045,335.851,382.26L335.851,382.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.935,390.846c12.697-6.788,28.068,3.237,30.381,9.046 C333.179,405.803,316.677,392.335,316.935,390.846L316.935,390.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M299.558,400.56c11.568-4.422,24.83,1.44,30.073,7.917 C323.462,411.46,307.32,414.697,299.558,400.56L299.558,400.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M283.726,405.545c13.263-1.49,25.96,8.586,28.736,14.292 C295.599,421.482,289.072,416.395,283.726,405.545L283.726,405.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M279.46,415.571c-7.351-5.568-13.829-7.388-23.854-9.209c-10.025-1.82-20.614-4.926-26.267-6.426 c-5.501-1.552,18.916,7.388,25.136,9.157C260.644,410.965,279.46,415.571,279.46,415.571L279.46,415.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M239.106,399.892c2.106-12.594-2.879-25.857-14.394-31.152 C222.14,377.891,230.315,393.414,239.106,399.892L239.106,399.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.724,393.364c6.222-10.539-4.164-24.059-11.823-30.639 C204.353,369.047,210.575,387.914,219.724,393.364L219.724,393.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M201.681,385.242c6.58-8.996-1.132-24.728-9.357-30.947 C189.087,363.188,192.325,379.123,201.681,385.242L201.681,385.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M183.739,373.932c5.911-8.483,1.8-21.643-6.733-30.229 C170.89,350.8,176.132,366.118,183.739,373.932L183.739,373.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M169.347,362.623c5.088-8.02-1.132-27.194-9.152-32.49 C156.648,337.226,159.322,357.277,169.347,362.623L169.347,362.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M157.779,359.59c1.542-11.465-18.506-24.162-26.681-23.801 C131.973,345.143,140.406,355.424,157.779,359.59L157.779,359.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M169.089,372.543c-9.459-9.662-27.707-9.662-34.185-7.659 C136.702,370.54,158.19,382.826,169.089,372.543L169.089,372.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M182.044,382.26c-13.263-3.548-21.848-6.427-29.765,1.798 C157.779,391.154,179.37,389.045,182.044,382.26L182.044,382.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M200.858,390.846c-12.644-6.788-27.965,3.237-30.279,9.046 C184.715,405.803,201.116,392.335,200.858,390.846L200.858,390.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M218.181,400.56c-11.515-4.422-24.725,1.44-29.968,7.917 C194.433,411.46,210.575,414.697,218.181,400.56L218.181,400.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M234.221,405.545c-13.365-1.49-26.062,8.586-28.786,14.292 C222.398,421.482,228.875,416.395,234.221,405.545L234.221,405.545z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M91.105,215.085c0,0-3.681,4.801,2.571,16.963c6.253,12.162,1.762,26.197,8.499,30.688 s0.284,13.398,8.002,19.33c7.718,5.933,27.999,19.585,41.999,21.18s27.6-12.548,35.677-2.108s6.312,17.799,13.931,18.611 c7.619,0.812,7.619-2.557,7.058-7.609s5.053-19.088,17.965-19.088s26.592-1.537,48.384-9.751 c21.792-8.214,32.458-12.144,35.265-25.056c2.807-12.912,10.788-28.178,26.166-21.107c15.378,7.072,14.344,3.755,19.072,0.361 c4.728-3.394,20.579,6.424,24.162,1.234c3.583-5.19-28.048-30.868-26.267-44.415s6.047-24.799,19.072-25.91 c13.025-1.111,9.656-15.707,23.13-23.006c13.474-7.298,19.68-8.132,30.331-18.943s38.659-32.695,38.659-32.695 s-54.491,26.096-65.39,28.481s-15.39,18.105-45.706,26.526s-32,11.789-55.018,16.842c-20.729,4.55-67.555,3.022-95.254-5.866 c-3.82-1.226-7.616,1.791-7.277,5.788c1.141,13.463,0.821,37.671-15.531,41.426c0,0-22.288-16.647-36.324-9.349 c-14.035,7.298-24.016,33.325-34.464,29.294S98,206.17,91.105,215.085z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.5fa1db0a35e7603ab94d849b8a460c9a.svg";
export { ForwardRef as ReactComponent };